<template>
    <div class="coupon-view right_auth">
        <div class="top">
            <span class="left">优惠券</span>
            <!-- <a href="/view/coupon/coupon.html" target="_blank" class="right">点击领取更多优惠券</a> -->
        </div>
        <div class="bottom">
            <ul class="genre">
                <li>
                    {{genreSelected.label}}
                    <img src="../assets/img/downs.png" alt="">
                    <ul class="choose">
                        <li v-for="ge in genre" :class="{on : ge == genreSelected}" @click="genreChange(ge)">{{ge.label}}</li>
                    </ul>
                </li>
                <li v-for="ti in time" @click="timeChange(ti.change)" :class="{on : ti.change == timeSelected.change}">
                    <span>{{ti.change.label}}</span>
                </li>
            </ul>
            <div v-if="timeSelected.data.length">
                <ul class="list coupon" v-if="genreSelected.type == 1">
                    <li v-for="da in timeSelected.data"
                        :class="{now : timeSelected.change.type == 1 && diff(da.discountStartTime,da.discountEndTime),
                             gray : timeSelected.change.type == 4 || !usable}">
                        <div class="top">
                            <p class="type" v-if="timeSelected.change.type == 1 && diff(da.discountStartTime,da.discountEndTime)">即将到期</p>
                            <p class="money"><span>￥</span>{{da.discountAmount}}</p>
                            <p class="condition">【满{{da.discountDoorsill}}可用】</p>
                            <p class="range">{{da.discountStartTime | time}}-{{da.discountEndTime | time}}</p>
                        </div>
                        <div class="bottom">
                            <p class="limit" v-jq-tips="da.discountDescription||''">{{da.discountDescription||'&nbsp'}}</p>
                            <button v-if="usable" onclick="service.creatOrder()">立即使用</button>
                            <button v-else>无法使用</button>
                        </div>
                    </li>
                </ul>
                <ul class="list fullcut" v-if="genreSelected.type == 2">
                    <li v-for="da in timeSelected.data"
                        :class="{now : timeSelected.change.type == 1 && diff(da.discountStartTime,da.discountEndTime),
                             gray : timeSelected.change.type == 4}">
                        <div class="top">
                            <p class="type" v-if="timeSelected.change.type == 1 && diff(da.discountStartTime,da.discountEndTime)">即将到期</p>
                            <p class="money"><span>￥</span>{{da.discountAmount}}</p>
                            <p class="condition" v-if="da.discountType == 1">【满{{da.discountDoorsill}}可用】</p>
                            <p class="condition" v-else>【全平台】</p>
                            <p class="range">{{da.discountStartTime | time}}-{{da.discountEndTime | time}}</p>
                        </div>
                        <div class="bottom">
                            <p class="limit" v-jq-tips="da.discountDescription||''">{{da.discountDescription||'&nbsp'}}</p>
                            <button v-if="usable" onclick="service.creatOrder()">立即使用</button>
                            <button v-else>无法使用</button>
                        </div>
                    </li>
                </ul>
                <div class="page_wrap">
                    <sd-pager ref="pager" :page-data="page" @page-change="pageChange"></sd-pager>
                </div>
            </div>
            <div class="g_empty" v-if="!timeSelected.data.length">
                <p class="info">没有相关优惠券~</p>
            </div>
        </div>
    </div>
</template>
<script type="es6">
   import sdPager from '../components/sdPager'
   import {util} from '../service/util'
   import { mapState, mapActions , mapGetters} from 'vuex'
   let API = util.api(['FINDMYDISCOUNT']);
   export default{
       components:{sdPager},
       data(){
           return{
               genre:[
                   {label:'可用满减券',type:1},
                   {label:'可用代金券',type:2}
               ],
               time: [
                   {
                       change:{
                           label:'进行中',
                           param:{
                               endStartTime: moment().format('YYYY-MM-DD'),
                               beginEndTime : moment().format('YYYY-MM-DD'),
                               useStatus : 1
                           },
                           type:1,
                       },
                       data:[]
                   },
                   {
                       change:{
                           label:'即将开始',
                           param:{
                               beginStartTime : moment().add(1,'days').format('YYYY-MM-DD'),
                               endStartTime : moment().add(7,'days').format('YYYY-MM-DD'),
                               useStatus : 1
                           },
                           type:2,
                       },
                       data:[]
                   },
                   {
                       change:{
                           label:'即将结束',
                           param:{
                               endStartTime : moment().format('YYYY-MM-DD'),
                               beginEndTime : moment().format('YYYY-MM-DD'),
                               endEndTime : moment().add(7,'days').format('YYYY-MM-DD'),
                               useStatus : 1
                           },
                           type:3,
                       },
                       data:[]
                   },
                   {
                       change:{
                           label:'已经结束',
                           param:{
                               beginEndTime : moment().subtract(7,'days').format('YYYY-MM-DD'),
                               endEndTime : moment().subtract(1,'days').format('YYYY-MM-DD')
                           },
                           type:4
                       },
                      data:[],
                   },
                   {
                       change:{
                           label:'已经使用',
                           param:{
                               useStatus : 2
                           },
                           type:5
                       },
                       data:[],
                   }
               ],
               genreSelected:{},
               timeSelected:{
                   change:{
                       label:'进行中',
                       param:{
                           beginStartTime: moment(),
                           endEndTime : moment(),
                           useStatus : 1
                       },
                       type:1,
                   },
                   data:[]
               },
               page:{
                   pageNo:1,
                   pageSize:12,
                   totalPage:1,
                   totalRecord:1
               }
           }
       },
       computed:{
           searchTranDiscountUser(){
               return{
                   discountType:this.genreSelected.type,
                   ...this.timeSelected.change.param,
                   page: {
                       pageNo : this.page.pageNo,
                       pageSize : this.page.pageSize,
                   }
               }
           },
           // 当前状态
           currentType() {
               return this.timeSelected.change.type;
           },
           // 能否使用
           usable() {
               return !(this.currentType == 4 || this.currentType == 2 || this.currentType == 5)
           }
       },
       methods:{
           genreChange(data){
               this.genreSelected = data;
               this.initPage();
               this.list();
           },
           timeChange(data){
               this.timeSelected.change = data;
               this.initPage();
               this.list();
           },
           list(){
               util.kAjax(API.FINDMYDISCOUNT,this.searchTranDiscountUser,(res)=>{
                   this.timeSelected.data = res.data.datas;
                   this.page.pageNo = res.data.pageNo;
                   this.page.totalPage = res.data.totalPage;
                   this.page.totalRecord = res.data.totalRecord;
               })
           },
           pageChange(){
               this.list();
           },
           initPage(){
               this.page = {
                   pageNo:1,
                   pageSize:12,
                   totalPage:1,
                   totalRecord:1
               }
           },
           diff(start,end){
               let s = moment().diff(moment(start), 'days');
               let e = moment().diff(moment(end), 'days');
               if(e > -7 && s > 0){
                   return true;
               }
           }
       },
       mounted(){
           this.genreSelected = this.genre[0];
           this.timeSelected.change = this.time[0].change;
           this.list();
       }
   }
</script>




// WEBPACK FOOTER //
// CouponView.vue?db8944f0